/**
 * Balken wachsen beim ersten Sichtbarwerden — überall, wo ein Balken steht,
 * oder nirgends (KONZEPT-gestaltungssystem.md, 11). Einmal je Baustein, nie
 * bei Datenwechsel; `prefers-reduced-motion` schaltet die Bewegung ab, dann
 * stehen die Balken sofort in voller Breite.
 *
 * Nutzung im Baustein: `@state() _gewachsen = false;` und in `firstUpdated`
 * `this._beenden = beobachteWachsen(this, () => (this._gewachsen = true));`
 * — die Breite wird mit `_gewachsen ? anteil : 0` gerendert, der Übergang
 * steht im CSS (`transition: width var(--portal-bar-duration) ease-out`).
 */
export function beobachteWachsen(ziel: Element, gewachsen: () => void): () => void {
  const reduziert =
    typeof window !== "undefined" &&
    window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  if (reduziert || typeof IntersectionObserver === "undefined") {
    gewachsen();
    return () => {};
  }
  const beobachter = new IntersectionObserver(
    (eintraege) => {
      if (eintraege.some((e) => e.isIntersecting)) {
        gewachsen();
        beobachter.disconnect();
      }
    },
    { threshold: 0.25 },
  );
  beobachter.observe(ziel);
  return () => beobachter.disconnect();
}
